import React from 'react'

import Page from '../page'

import PortfolioSingleComponent from '../components/portfolio/portfolioSingle'
import SEO from '../components/seo'

class PortfolioSinglePage extends Page {
  onMountGlobalState(state) {
    return {
      ...state,
      whiteLogo: false,
    }
  }

  render() {
    return [
      <SEO
        {...this.props.data.portfolio}
        {...this.props.pathContext}
        key="seo"
      />,
      <PortfolioSingleComponent data={this.props.data} key="page" />,
    ]
  }
}

export default PortfolioSinglePage

export const pageQuery = graphql`
  query currentPortfolioQuery($id: String!, $next: String, $prev: String) {
    portfolio: wordpressWpPortfolio(id: { eq: $id }) {
      title
      id
      wordpress_id
      featured_media {
        localFile {
          childImageSharp {
            bgColor
            res_100: sizes(
              maxWidth: 1870
              maxHeight: 1000
              quality: 85
              traceSVG: { color: "#821749" }
            ) {
              ...GatsbyImageSharpSizes_withWebp_noBase64
            }
            ...SEOImageFragment
          }
        }
      }
      yoast {
        title
        metadesc
      }
      acf {
        show_featured_image
        show_header_spacer
      }
      tiles {
        type
        text
        size
        croppedImage {
          bgColor
          aspectRatio
          src
          srcSet
          srcWebp
          srcSetWebp
          sizes
        }
      }
    }
    prev: wordpressWpPortfolio(id: { eq: $prev }) {
      title
      id
      slug
      lang
      featured_media {
        localFile {
          childImageSharp {
            resolutions(width: 56, height: 56, traceSVG: { color: "#821749" }) {
              ...GatsbyImageSharpResolutions_withWebp_noBase64
            }
          }
        }
      }
    }
    next: wordpressWpPortfolio(id: { eq: $next }) {
      title
      id
      slug
      lang
      featured_media {
        localFile {
          childImageSharp {
            resolutions(width: 56, height: 56, traceSVG: { color: "#821749" }) {
              ...GatsbyImageSharpResolutions_withWebp_noBase64
            }
          }
        }
      }
    }
  }
`

/*
// layout_portfolio {
        //   __typename
        //   ... on WordPressAcf_image {
        //     wide
        //     tall
        //     obrazek {
        //       localFile {
        //         childImageSharp {
        //           sizes(maxWidth: 1885, traceSVG: { color: "#821749" }) {
        //             ...GatsbyImageSharpSizes_withWebp
        //           }
        //           res_100: sizes(
        //             maxWidth: 1885
        //             maxHeight: 1060
        //             traceSVG: { color: "#821749" }
        //           ) {
        //             ...GatsbyImageSharpSizes_withWebp
        //           }
        //           res_75: sizes(
        //             maxWidth: 1403
        //             maxHeight: 1060
        //             traceSVG: { color: "#821749" }
        //           ) {
        //             ...GatsbyImageSharpSizes_withWebp
        //           }
        //           res_50: sizes(
        //             maxWidth: 922
        //             maxHeight: 1060
        //             traceSVG: { color: "#821749" }
        //           ) {
        //             ...GatsbyImageSharpSizes_withWebp
        //           }
        //           res_25: sizes(
        //             maxWidth: 441
        //             maxHeight: 1060
        //             traceSVG: { color: "#821749" }
        //           ) {
        //             ...GatsbyImageSharpSizes_withWebp
        //           }
        //         }
        //       }
        //     }
        //   }
        //   ... on WordPressAcf_text {
        //     wide
        //     text
        //   }
        // }
        */



// WEBPACK FOOTER //
// ./src/templates/portfolio-single.js